import { CacheDescriptor } from '../store/schema/CacheDescriptor';
import { CacheItem } from '../store/schema/CacheItem';
import { ItemCache } from '../store/schema/ItemCache';

export function getDescriptors<T extends CacheItem, U extends CacheDescriptor>(
    store: ItemCache<T, U>
): U[] {
    return [...store.descriptors.values()];
}
